import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '@app/services/api.service';
import {
  AllOpportunityFilters,
  OppListItem,
  OpportunityTableData,
  SubscribeToOpp,
  UnsubscribeFromOpp,
} from '@app/models/opportunities';
import { ApplicationConstants } from '@app/constants/application.constants';

@Injectable({
  providedIn: 'root',
})
export class OpportunitiesService {
  constructor(
    private api: ApiService,
    private http: HttpClient
  ) {}

  // All Opportunities
  getOpportunities(oppFilters: AllOpportunityFilters = {}): Observable<OppListItem[]> {
    return this.api.get(ApplicationConstants.api.getOpportunitiesEndpoint, {
      regionId: oppFilters.regionId ?? 0,
      licenseId: oppFilters.licenseId ?? 0,
      agencyId: oppFilters.agencyId ?? 0,
      searchQuery: oppFilters.searchQuery ?? '',
    });
  }

  // Opportunities Table Data
  getOpportunityTableData(): Observable<OpportunityTableData> {
    return this.http.get<OpportunityTableData>(ApplicationConstants.api.getOpportunityTableDataEndpoint);
  }

  // Subscribe To Opportunity
  updateSubscribeToOpp(oppAgencyToken: string, oppEventToken: string): Observable<SubscribeToOpp> {
    const payload = {
      agencyToken: oppAgencyToken,
      eventToken: oppEventToken,
    };

    return this.http.post<SubscribeToOpp>(ApplicationConstants.api.postSubscribeToOppEndpoint, payload);
  }

  // Unsubsrcibe From Opportunity
  updateUnsubscribeFromOpp(oppAgencyToken: string, oppEventToken: string): Observable<UnsubscribeFromOpp> {
    const payload = {
      agencyToken: oppAgencyToken,
      eventToken: oppEventToken,
    };

    return this.http.post<UnsubscribeFromOpp>(ApplicationConstants.api.postUnsubscribeFromOppEndpoint, payload);
  }
}
